import {post} from "../util/http.service";

export const createSupport = support => post("/supports", support);
